import {
  MutationCreateCompletedTaskArgs,
  Enum_Completedtask_Type,
  DailyTaskHasBeenCompletedQuery,
  GetUserTrackingDataQuery,
  GetUserTrackingDataQueryVariables,
} from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { getAuthentication } from '@/hooks/useAuthentication';
import { MUTATION_COMPLETE_TASK } from '@/graphql/mutations/daily/completed-tasks';
import {
  QUERY_COMPLETED_TASK,
  QUERY_TRACKING_EMOTION,
  QUERY_USER_TRACKING_DATA,
} from '@/graphql/queries/daily/completed-tasks';
import { Caches } from '@/@types/caches.enum';

export interface CompletedTask {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entity: any;
  type: Enum_Completedtask_Type;
}

export const completeTask = async ({ entity, type }: CompletedTask) => {
  const apolloClient = initializeApollo();

  const inputData = {
    type,
    done: true,
    relationID: entity?.id ? parseInt(entity?.id) : 0,
    day: new Date().toISOString().split('T')[0],
    metadata: JSON.stringify(entity || {}),
    user: getAuthentication()?.user?.id,
  };

  const { data, error } = await requestHandler(
    apolloClient.mutate<MutationCreateCompletedTaskArgs>({
      mutation: MUTATION_COMPLETE_TASK,
      variables: {
        data: inputData,
      },
    }),
  );

  apolloClient.cache.evict({
    fieldName: Caches.VERIFY_IF_TASK_HAS_BEEN_COMPLETED,
  });

  return { data, error };
};

export const dailyTaskHasBeenCompleted = async (id: string | null, type: Enum_Completedtask_Type) => {
  const apolloClient = initializeApollo();

  const inputData = {
    day: new Date().toISOString().split('T')[0],
    type,
    relationID: parseInt(id || '0'),
    userId: getAuthentication()?.user?.id,
  };

  const { data, error } = await requestHandler(
    apolloClient.query<DailyTaskHasBeenCompletedQuery>({
      query: QUERY_COMPLETED_TASK,
      variables: {
        ...inputData,
      },
      fetchPolicy: 'cache-first',
    }),
  );

  const isCompleted = (data?.completedTasks?.data?.length || 0) > 0;

  return { data: { isCompleted }, error };
};

export const getTrackingEmotions = async (startDay: Date, endDay: Date) => {
  const apolloClient = initializeApollo();

  const inputData = {
    endDay: endDay.toISOString().split('T')[0],
    startDay: startDay.toISOString().split('T')[0],
    type: Enum_Completedtask_Type.EmotionalWheel,
    relationID: parseInt('0'),
    userId: getAuthentication()?.user?.id,
  };

  const { data, error } = await requestHandler<{ emotionTracker: unknown }>(
    apolloClient.query({
      query: QUERY_TRACKING_EMOTION,
      variables: {
        ...inputData,
      },
    }),
  );

  return { data: data?.emotionTracker, error };
};

export const getUserTrackingData = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>({
      query: QUERY_USER_TRACKING_DATA,
    }),
  );

  return { data, error };
};
